
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/join/profile",
      function () {
        return require("private-next-pages/join/profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/join/profile"])
      });
    }
  